import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/login'
import Main from '../views/main'
import NotFound from '../views/error'
import Home from '../views/home'
import User from '../views/sys/user'
import Role from '../views/sys/role'
import UserRole from '../views/sys/userrole'
import RoleRight from '../views/sys/roleright'
import MainMenu from '../views/sys/mainmenu'
import Dictionary from '../views/sys/dictionary'
import Button from '../views/sys/button'
import PushInfo from '../views/push/pushinfo'
import JumpParam from '../views/base/jumpparam'
import ArticleEdit from '../views/content/articleedit'
import ArticleList from '../views/content/articlelist'
import PushArticle from '../views/push/pusharticle'
import Group from '../views/discovery/group'
import PushDiscovery from '../views/discovery/pushdiscovery'
import ReleaseList from '../views/discovery/releaselist'
import AdList from '../views/discovery/pushad'
import PushSentenceList from '../views/discovery/pushSentenceList'
Vue.use(Router)

export default new Router({
 // mode:'history',
  routes: [   
    {
        path: '/login',
        component: Login,
        name: ''
    },
     {
        path: '/',
        component: Main,
        name: '首页',
        children: [
             { path: '/home', component: Home, name: '主页' }
         ]
    },   
    {
        path: '/',
        component: Main,
        name: '系统管理',
        children: [
            { path: '/addmenu', component: MainMenu, name: '添加菜单' },
            { path: '/button', component: Button, name: '菜单按钮'},
            { path: '/dictionary', component: Dictionary, name: '数据字典' },
            { path: '/user', component: User, name: '用户设置' },
            { path: '/role', component: Role, name: '角色设置' },
            { path: '/userrole', component: UserRole, name: '用户角色' },
            { path: '/right', component: RoleRight, name: '角色权限' }
        ]
    },
    {
        path: '/',
        component: Main,
        name: '基础设置',
        children: [
            { path: '/jumpparam', component: JumpParam, name: '跳转参数设置' }
           
        ]
    },
     {
        path: '/',
        component: Main,
        name: '推送管理',
        children: [
            { path: '/info', component: PushInfo, name: '消息推送' },
            { path: '/content', component: PushArticle, name: '内容推送' }
           
        ]
    }, 
      {
        path: '/',
        component: Main,
        name: '推文管理',
        children: [
            { path: '/discoverygroup', component: Group, name: '分类设置' },
            { path: '/discoverylist', component: PushDiscovery, name: '推文列表' },
            { path: '/releaselist', component: ReleaseList, name: '发布推文' },  
            { path: '/pushad', component: AdList, name: '发布相关APP' },
            { path: '/sentence', component: PushSentenceList, name: '推送例句' }          
        ]
    },  
     {
        path: '/',
        component: Main,
        name: '文章管理',
        children: [
            { path: '/articlelist', component: ArticleList, name: '文章列表' },
            { path: '/articleedit', component: ArticleEdit, name: '文章编辑' }
           
        ]
    },   

    
     {
        path: '/',
        component: Main,
        name: '',
        children: [
             { path: '/error', component: NotFound, name: '主页' }
         ]
    },
     {
        path: '*',        
        redirect: { path: '/error' }
    }

  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js